var _rect, _g, _rect2, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackBeneficios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1720,
    height: 726,
    viewBox: "0 0 1720 726",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_124_167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1720,
    height: 726
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1720,
    height: 726,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_124_167)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_124_167)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1720,
    height: 726,
    rx: 20,
    fill: "#1F375B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_124_167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1720,
    height: 726
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1720,
    height: 726,
    rx: 20,
    fill: "#1F375B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_124_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2854 64.3018C104.895 49.6665 113.101 29.8334 113.104 9.15439C113.107 -11.5246 104.907 -31.3603 90.3016 -45.9999L80.4722 -36.1706C92.1173 -24.074 98.5518 -7.89162 98.3922 8.89852C98.2326 25.6887 91.4918 41.7459 79.6189 53.6189C67.7459 65.4919 51.6886 72.2326 34.8985 72.3922C18.1083 72.5518 1.92572 66.1176 -10.1708 54.4725L-20.0002 64.3018C-5.36338 78.9039 14.4676 87.1044 35.1426 87.1044C55.8176 87.1044 75.6486 78.9039 90.2854 64.3018Z",
    fill: "url(#paint0_linear_124_167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.83 635.898C1668.55 627.417 1686.04 625.123 1702.45 629.518C1718.87 633.913 1732.87 644.639 1741.38 659.342L1753.42 652.392C1742.89 634.855 1725.89 622.157 1706.09 617.034C1686.29 611.91 1665.26 614.77 1647.55 624.998C1629.83 635.225 1616.84 652.003 1611.38 671.715C1605.91 691.428 1608.41 712.498 1618.33 730.387L1630.37 723.436C1621.89 708.713 1619.6 691.228 1624 674.817C1628.39 658.405 1639.12 644.409 1653.83 635.898Z",
    fill: "url(#paint1_linear_124_167)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_124_167)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1618.5,
    cy: -45.5,
    r: 249.5,
    fill: "url(#paint2_linear_124_167)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_124_167)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 753,
    r: 243,
    fill: "url(#paint3_linear_124_167)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_124_167",
    x: -84,
    y: -66,
    width: 1888,
    height: 894,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_124_167"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.780392 0 0 0 0 0.972549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_124_167"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_124_167"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.780392 0 0 0 0 0.972549 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_124_167",
    result: "effect2_dropShadow_124_167"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_124_167",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_124_167",
    x: 735,
    y: -929,
    width: 1767,
    height: 1767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 317,
    result: "effect1_foregroundBlur_124_167"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_124_167",
    x: -798,
    y: -124,
    width: 1754,
    height: 1754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 317,
    result: "effect1_foregroundBlur_124_167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_124_167",
    x1: 61.9929,
    y1: -317.683,
    x2: 40.0568,
    y2: 187.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_124_167",
    x1: 1722.24,
    y1: 533.983,
    x2: 1570.41,
    y2: 1015.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_124_167",
    x1: 818.492,
    y1: 1561.35,
    x2: 2630.33,
    y2: 731.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_124_167",
    x1: -700.166,
    y1: 2317.99,
    x2: 1064.47,
    y2: 1509.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBeneficios);
export default __webpack_public_path__ + "static/media/back-beneficios.c6946163afba6c6c1d06446959dcee6b.svg";
export { ForwardRef as ReactComponent };